import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';

export const Hero = () => {
  const location = useLocation();

  const scrollTo = (e, id) => {
    if (location.pathname === '/') {
      e.preventDefault();
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.history.replaceState(null, '', `/#${id}`);
      }
    }
  };

  return (
    <section id="home" className="relative min-h-[100svh] overflow-hidden bg-gradient-to-br from-gray-50 via-blue-50 to-gray-100 flex items-center pt-24 md:pt-28 lg:pt-32 pb-16 md:pb-20">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-72 h-72 bg-blue-400 rounded-full mix-blend-multiply filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-72 h-72 bg-gray-400 rounded-full mix-blend-multiply filter blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full">
        <div className="max-w-4xl mx-auto text-center hero-animate">
          {/* Kicker */}
          <p
            data-testid="hero-kicker"
            className="text-xs sm:text-sm font-semibold tracking-[0.22em] text-gray-500 uppercase mb-4 md:mb-6"
          >
            Welcome to
          </p>

          {/* Primary — company name */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold bg-gradient-to-r from-blue-600 via-blue-700 to-blue-900 bg-clip-text text-transparent mb-8 md:mb-12 leading-tight pb-1">
            Xiamen Tower Technology
          </h1>

          {/* Secondary — positioning line */}
          <h2
            data-testid="hero-secondary-headline"
            className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-5 md:mb-6 leading-snug"
          >
            Industrial Project Support{' '}
            <span className="text-blue-700">in China</span>
          </h2>

          {/* Supporting sentence */}
          <p className="text-base md:text-lg text-gray-700 mb-10 md:mb-12 max-w-2xl mx-auto leading-relaxed">
            Engineers, supervisors and technical specialists for installation, commissioning, project coordination and on-site support throughout China.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              asChild
              size="lg"
              className="bg-blue-700 hover:bg-blue-800 text-white px-8 py-6 text-base font-semibold shadow-lg hover:shadow-xl transition-all group"
            >
              <Link
                to="/#contact"
                data-testid="hero-cta-discuss-project"
                onClick={(e) => scrollTo(e, 'contact')}
              >
                Discuss Your Project
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="border-2 border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white px-8 py-6 text-base font-semibold transition-all"
            >
              <Link
                to="/#services"
                data-testid="hero-cta-services"
                onClick={(e) => scrollTo(e, 'services')}
              >
                Our Services
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
